import app from 'app';
import 'm/ProgrammerModel';

app.namespace.Collection.ProgrammerCollection = Backbone.Collection.extend({
  '?': 'ProgrammerCollection',

  model: app.namespace.Model.ProgrammerModel,

  comparatorFields: [
    {
      asc: true,
      from: function (model) {
        return model.get('label');
      },
    },
  ],

  parse: function (raw) {
    return raw;
  },

  initialize: function () {},

  /**
   * Has only one programmer (aka production line)
   * @return {boolean}
   */
  isSingle: function () {
    return 1 === this.length;
  },
});

export default app.namespace.Collection.ProgrammerCollection;
